var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var getTranscodingStatusQuery = function (videoId) { return ({
    query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query($id: String!) {\n      transcodingStatus(videoId: $videoId, lang: $lang)\n        @rest(type: TranscodingStatus, path: \"/transcodingStatus/:videoId\", endpoint: query) {\n        jobId\n        pipelineId\n        videoId\n        status\n        version\n        language\n      }\n    }\n  "], ["\n    query($id: String!) {\n      transcodingStatus(videoId: $videoId, lang: $lang)\n        @rest(type: TranscodingStatus, path: \"/transcodingStatus/:videoId\", endpoint: query) {\n        jobId\n        pipelineId\n        videoId\n        status\n        version\n        language\n      }\n    }\n  "]))),
    variables: { videoId: videoId },
    pollInterval: 7 * 1000,
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/getVideoTranscodingStatus.ts
// module id = 784
// module chunks = 81